<template>
  <!-- Home Section 03 -->
  <div>
    <section class="info_center">
      <div class="container">
        <div class="carousel-caption d-none d-md-block animation_colum">
          <h5>We are hiring</h5>
          <div class="row_home_right zoom animation_button">
            <router-link to="/registration">
              <button>Apply Now</button>
            </router-link>
          </div>
        </div>
      </div>

      <div class="">
        <div class="info_head" data-aos="fade-left">
          <VueSlickCarousel
            v-bind="setting"
            ref="c1"
            :asNavFor="$refs.c2"
            :focusOnSelect="true"
            :slidesToShow="1"
            :autoplay="true"
            :speed="300"
            :autoplaySpeed="4000"
            @beforeChange="syncSliders"
            :adaptiveHeight="true"
          >
            <a class="">
              <img class="" src="../assets/img/Info_center.jpg" style="width: 100%" />
            </a>
            <a class="">
              <img class="" src="../assets/img/Info_center1.jpg" style="width: 100%" />
            </a>
            <a class="">
              <img class="" src="../assets/img/info_center2.jpg" style="width: 100%" />
            </a>
            <a class="">
              <img class="" src="../assets/img/info_center3.jpg" style="width: 100%" />
            </a>
            <a class="">
              <img class="" src="../assets/img/info_center2.jpg" style="width: 100%" />
            </a>
            <template #prevArrow="">
              <div class="custom-arrow"></div>
            </template>
            <template #nextArrow="">
              <div class="custom-arrow"></div>
            </template>
          </VueSlickCarousel>
          <div class="info_head_2">
            <VueSlickCarousel
              v-bind="settings"
              ref="c2"
              :asNavFor="$refs.c1"
              :focusOnSelect="true"
              :centerMode="3"
              :slidesToShow="3"
              :accessibility="true"
              @beforeChange="syncSliders"
            >
              <a class="">
                <img
                  class=""
                  src="../assets/img/info_center_icon.jpg"
                  style="width: 100%"
                />
              </a>
              <a class="">
                <img
                  class=""
                  src="../assets/img/info_center_icon1.jpg"
                  style="width: 100%"
                />
              </a>
              <a class="">
                <img
                  class=""
                  src="../assets/img/info_center_icon2.jpg"
                  style="width: 100%"
                />
              </a>
              <a class="">
                <img
                  class=""
                  src="../assets/img/info_center_icon3.jpg"
                  style="width: 100%"
                />
              </a>
              <a class="">
                <img
                  class=""
                  src="../assets/img/info_center_icon2.jpg"
                  style="width: 100%"
                />
              </a>
              <template #prevArrow="">
                <div class="custom-arrow"></div>
              </template>
              <template #nextArrow="">
                <div class="custom-arrow"><span class="next_icon_slick"></span></div>
              </template>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
      <div class="row d-none d-md-block">
        <div class="bottom_content_info animation_colum">
          <p class="fadeInRight">
            This volunteer management software can be a perfect way for your volunteers to
            establish themselves, both personally and professionally.
          </p>
        </div>
      </div>
    </section>
    <section>
      <div class="bv-example">
        <div class="subraw1"></div>
        <b-row class="subraw leng">
          <li md="3" class="subnab mr-2">
            <a
              @click="selectServices()"
              v-bind:class="{ color_active_page: currentPage == 'Services' }"
              active-class="active"
              exact
              class="text"
              >Services</a
            >
          </li>
          <li md="3" class="subnab mr-2">
            <a
              @click="selectNews()"
              v-bind:class="{ color_active_page: currentPage == 'News' }"
              active-class="active"
              exact
              class="text"
              >News</a
            >
          </li>
          <li md="3" class="subnab mr-2">
            <a
              @click="selectOurTeam()"
              v-bind:class="{ color_active_page: currentPage == 'OurTeam' }"
              active-class="active"
              exact
              class="text"
              >Our team</a
            >
          </li>
          <li md="3" class="subnab mr-2">
            <a
              @click="selectCareer()"
              v-bind:class="{ color_active_page: currentPage == 'Career' }"
              active-class="active"
              exact
              class="text"
              >Career</a
            >
          </li>
          <li md="3" class="subnab mr-2">
            <a
              @click="selectCovid()"
              v-bind:class="{ color_active_page: currentPage == 'Covid' }"
              active-class="active"
              exact
              class="text"
              >Covid-19</a
            >
          </li>
          <div class="dropdown">
            <span class="div">
              <select class="dropbtn" id="zilla" name="zilla">
                <option selected value="">City</option>
                <option value="1">Dhaka</option>
                <option value="2">Chittagong</option>
                <option value="3">Khulna</option>
                <option value="4">Rajshahi</option>
                <option value="5">Comilla</option>
                <option value="6">Rangpur</option>
                <option value="7">Sylhet</option>
                <option value="8">Barisal</option>
              </select>
              <span class="icon-drop"><i class="fas fa-caret-down"></i></span>
            </span>
          </div>
          <b-col md="2">
            <div class="container1">
              <div class="searchbox">
                <input type="text" class="searchbox__input" placeholder="Search" />
                <SearchIcon class="searchbox__icon" />
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="currentPage == 'Services'">
        <Service />
      </div>
      <div v-if="currentPage == 'News'">
        <News />
      </div>
      <div v-if="currentPage == 'OurTeam'">
        <OurTeam />
      </div>
      <div v-if="currentPage == 'Career'">
        <Career />
      </div>
      <div v-if="currentPage == 'Covid'">
        <Covid />
      </div>
    </section>
  </div>
</template>
<script>
import Service from "./InfoCenter/services";
import News from "./InfoCenter/news";
import OurTeam from "./InfoCenter/our_team";
import Career from "./InfoCenter/career";
import Covid from "./InfoCenter/covid";
import SearchIcon from "../assets/svg/search";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  name: "MyComponent",
  components: {
    VueSlickCarousel,
    Service,
    News,
    OurTeam,
    Career,
    Covid,
    SearchIcon,
  },
  data() {
    return {
      settings: {
        centerMode: 3,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 840,
            settings: {
              centerMode: 2,
              slidesToShow: 2,
            },
          },
        ],
      },
      setting: {},
      currentPage: "Services",
    };
  },
  mounted() {
    console.clear();
  },
  methods: {
    selectServices() {
      this.currentPage = "Services";
    },
    selectNews() {
      this.currentPage = "News";
    },
    selectOurTeam() {
      this.currentPage = "OurTeam";
    },
    selectCareer() {
      this.currentPage = "Career";
    },
    selectCovid() {
      this.currentPage = "Covid";
    },
    reloadRouter() {
      this.mKey = !this.mKey;
      this.wKey = !this.wKey;
    },

    syncSliders() {
      this.$refs.c1.next();
      this.$refs.c2.next();
      this.$refs.c1.prev();
      this.$refs.c2.prev();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "/assets/css/slick-theme.css";
.color_active_page {
  background-color: #07cddb !important;
  color: #000 !important;
  font-weight: 600;
}
.dropdown .dropbtn {
  outline: none;
  border-bottom: 1px solid #706f6f !important;
}
.dropdown select option {
}
.bv-example .subnab a {
  cursor: pointer;
}
.app-button {
  background-color: #07cddb;
  border-radius: 28px;
  width: 140px;
  margin: 0 20px;
  display: inline-block;
  line-height: 40px;
  font-weight: 500;
}
.next_icon_slick {
  width: 50px;
  height: 2px;
  background: #07cddb;
}
.bottom_content_info p {
  bottom: -10px;
  font-size: 24px;
  width: 60vw;
  position: absolute;
  background: rgb(29 28 28 / 92%);
  padding: 20px 20px 20px 100px;
  margin-left: -70px;
}
.app-button_b {
  border-radius: 28px;
  width: 140px;
  margin: 0 20px;
  display: inline-block;
  line-height: 40px;
  font-weight: 500;
}
.slick-slider {
  position: relative;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  width: 110%;
}
.slick-slider li {
  position: relative;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  float: left;
}
.slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: left;
}

.heading_txt .getting_line {
  width: 50px;
  height: 3px;
  background: #00dcff;
  margin-top: 20px;
  position: absolute;
}
.carousel-caption {
  position: absolute;
  right: auto;
  bottom: 50%;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
.text_colum {
  padding-top: 280px;
  padding-left: 190px;
}
.text_colum h4 {
  font-size: 46px;
}
.text_colum p {
  font-size: 32px;
  padding-top: 15px;
}
.section_3-button {
  width: 430px;
  padding-top: 30px;
  margin-left: 20px;
}
.text_colum b {
  font-size: 26px;
  color: #00dcff;
  cursor: pointer;
  padding-left: 80px;
}
.search-container input {
  font-size: 20px;
  height: 45px;
  width: 240px;
}
.search-container {
  font-size: 20px;
  border-radius: 12px;
  opacity: 1;
  width: 280px;
  height: 45px;
  margin-left: -20px;
}
.search-container button {
  font-size: 5px;
}
.bv-example-row {
  text-align: left;
}
.container1 {
  width: 100vw;
  height: 2vh;
  display: flex;
  align-items: center;
  margin-top: -15px;
  display: contents;
  margin-right: -330px;
}
.container1 .searchbox {
  position: relative;
  display: block;
  width: 400px;
  max-width: 43px;
  transition: 0.4s linear;
  overflow: hidden;
  float: right;
  margin-top: 0px;
  box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
  border-radius: 50px;
  margin-right: 0px;
}
.container1 .searchbox .searchbox__input {
  display: block;
  appearance: none;
  width: 100%;
  border: none;
  outline: none;
  border-radius: 50px;
  background-color: #000;

  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: 0.4s linear;
  font-weight: 600;
}
.container1 .searchbox .searchbox__input::placeholder {
  color: #fff;
}
.container1 .searchbox:focus-within .searchbox__input::placeholder {
  color: #24233a;
}
.container1 .searchbox .searchbox__icon {
  position: absolute;
  right: calc(53px / 2);
  top: 50%;
  transform: translate(50%, -50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
  margin-right: -6px;
  color: #07cddb;
}
.container1 .searchbox .searchbox__icon path {
  fill: rgb(0, 119, 255);
  transition: 0.4s linear;
}
.container1 .searchbox:focus-within {
  max-width: 120%;
}
.container1 .searchbox:focus-within .searchbox__input {
  background-color: #fff;
  padding-right: 50px;
  color: #24233a;
}
.container1 .searchbox:focus-within .searchbox__icon path {
  fill: rgb(0, 119, 255);
}
.search-container {
  display: none;
}
@media (max-width: 3101px) {
  .bottom_content_info p {
    bottom: -10px;
    font-size: 24px;
    width: 70vw;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 20px 20px 20px 220px;
    margin-left: -220px;
  }
}
@media (max-width: 1920px) {
  .text_colum {
    padding-top: 200px;
    padding-left: 100px;
  }
  .bottom_content_info p {
    bottom: -10px;
    font-size: 22px;
    width: 60vw;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 20px 20px 20px 180px;
    margin-left: -140px;
  }
}
@media (max-width: 1700px) {
  .text_colum {
    padding-top: 200px;
    padding-left: 100px;
  }
  .bottom_content_info p {
    bottom: -10px;
    font-size: 22px;
    width: 60vw;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 10px 20px 10px 150px;
    margin-left: -120px;
  }
}
@media (max-width: 1200px) {
  .text_colum {
    padding-top: 120px;
    padding-left: 70px;
  }
  .bottom_content_info p {
    bottom: -10px;
    font-size: 18px;
    width: 60vw;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 10px 20px 10px 150px;
    margin-left: -120px;
  }
  .text_colum h4 {
    font-size: 46px;
  }
  .text_colum p {
    font-size: 32px;
    padding-top: 15px;
  }
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: 20px;
  }
  .text_colum b {
    font-size: 24px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 60px;
  }
  .bv-example .subnab a {
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    padding: 7px;
    width: 110px;
    height: 38px;
  }
}
@media (max-width: 1024px) {
  .text_colum {
    padding-top: 180px;
    padding-left: 50px;
  }
  .text_colum h4 {
    font-size: 34px;
  }
  .text_colum p {
    font-size: 24px;
    padding-top: 15px;
  }
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: 20px;
  }
  .text_colum b {
    font-size: 22px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 60px;
  }
  .heading_txt .getting_line {
    width: 40px;
    height: 2.5px;
    background: #00dcff;
    margin-top: 20px;
    position: absolute;
  }
  .bottom_content_info p {
    bottom: -12px;
    font-size: 18px;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 10px 20px 10px 80px;
    margin-left: -120px;
  }
}
@media (max-width: 920px) {
  .section_3-button {
    width: 430px;
    padding-top: 30px;
    margin-left: -20px;
  }
  .text_colum h4 {
    font-size: 32px;
  }
  .content-right-content {
    width: 95%;
    margin-top: -10%;
  }
  .text_colum p {
    font-size: 22px;
    padding-top: 15px;
  }

  .text_colum b {
    font-size: 18px;
    color: #00dcff;
    cursor: pointer;
    padding-left: 40px;
  }
  .heading_txt .getting_line {
    width: 30px;
    height: 2.5px;
    background: #00dcff;
    margin-top: 14px;
    position: absolute;
  }
  .bottom_content_info p {
    bottom: -12px;
    font-size: 14px;
    position: absolute;
    background: rgb(29 28 28 / 92%);
    padding: 5px 8px 5px 90px;
    margin-left: -120px;
  }
}
@media (max-width: 768px) {
  .col {
    -ms-flex-preferred-size: 0;
    flex-basis: auto;
  }
  .section_3-button .col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    width: 10px;
    margin-left: -20px;
  }
  .home_1 .col-sm-5 {
    max-width: 100%;
  }
  .home_1 .col-sm-7 {
    max-width: 100%;
  }
}

.subscribe_button_b {
  color: #fff;
  font-size: 22px;
}
.email_sent_feild {
  padding: 15px 0px 20px 0px;
  margin-left: -15px;
}
.email_sent_feild input {
  padding: 25px 10px;
  border-radius: 8px;
}
.d-md-block {
  position: absolute;
  left: 8%;
}
/* Create two equal columns that floats next to each other */
.column {
  float: left;
  width: 35%;
  padding: 10px;
  height: auto;
}
.column1 {
  float: left;
  width: 65%;
  padding: 10px;
  height: auto;
}

.home-page .column .text_colum {
  padding-left: 35%;
}
.home-page .column .text_colum h4 {
  margin-top: 40%;
  font-size: 44px;
}
.home-page .column .text_colum p {
  margin-top: 2%;
  font-weight: 500;
  font-size: 32px;
}
.home-page .column .text_colum b {
  font-weight: 400;
  color: #07cddb;
  font-size: 24px;
}

@media screen and (max-width: 767px) {
  .column {
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
  }
  .column1 {
    float: left;
    width: 100%;
    padding: 5px;
    height: auto;
    margin-left: 20px;
  }
  /* Clear floats after the columns */
  .row:after {
    content: "";
    display: table;
    clear: both;
  }
  .content-right-content,
  .content-left-content {
    padding-top: 0px;
    text-align: left;
    padding-left: 25px;
    padding-right: 25px;
  }
  .text_colum {
    padding-top: 50px;
    padding-left: 50px;
  }
  .content-right-content,
  .content-left-content {
    padding-top: 0px;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
  }
  .content-right-content {
    width: 100%;
    margin-top: -10%;
  }
  .section_3-button {
    width: 330px;
    padding-top: 30px;
    margin-left: -20px;
  }
}
@media screen and (max-width: 480px) {
  .home-page .column h4 {
    margin-top: 10%;
    padding-left: 0%;
    font-size: 32px;
    text-align: center;
  }
  .home-page .column p {
    margin-top: 2%;
    padding-left: 0%;
    padding-bottom: 20px;
    font-size: 24px;
    text-align: center;
  }
}

.phone-nav {
  display: none;
}
.container1 {
  width: auto;
  height: 2vh;
  display: flex;
  align-items: center;
  margin-top: 8px;
  display: contents;
}
.div {
  z-index: 1005;
}

.container1 .searchbox .searchbox__input {
  display: block;
  appearance: none;
  width: 100%;
  border: none;
  outline: none;
  border-radius: 12px;
  padding: 6px 30px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  transition: 0.4s linear;
  font-weight: 600;
  padding-left: 20px;
}
.container1 .searchbox .searchbox__input::placeholder {
  color: rgb(114, 113, 113);
}
.container1 .searchbox:focus-within .searchbox__input::placeholder {
  color: #24233a;
}
.form-row {
  list-style: none;
}
.container1 .searchbox .searchbox__icon {
  position: absolute;
  right: calc(53px / 2);
  top: 50%;
  transform: translate(50%, -50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
  margin-right: -6px;
}
.container1 .searchbox .searchbox__icon path {
  fill: rgb(0, 119, 255);
  transition: 0.4s linear;
}
.container1 .searchbox:focus-within {
  max-width: 160%;
}
.container1 .searchbox:focus-within .searchbox__input {
  background-color: #fff;
  padding-right: 50px;
  color: #24233a;
}
.container1 .searchbox:focus-within .searchbox__icon path {
  fill: rgb(0, 119, 255);
}
.search-container {
  display: none;
}
.hideSearch {
  display: none;
}
.icon {
  color: #0077ff;
}

.dropdown {
  margin-right: 0px;
}
#home .bv-example-row {
  padding: 5px;
  display: flex;
  /* position: relative; */
  /* -webkit-flex-direction: row; */
  flex-direction: row;
  justify-content: center;
}
.subraw {
  list-style: none;
  top: 40px;
  z-index: 1001;
  height: 80px;
  margin-left: 9%;
  display: -webkit-flex;
  display: -ms-flexbox;
  /* display: flex; */
  /* position: relative; */
  /* -webkit-flex-direction: row; */
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: left;
}
.subraw1 {
  top: 0px;
  height: 40px;
  z-index: 1001;
}
.bv-example .subnab a {
  width: 130px;
  height: 45px;
  padding: 6px;
  text-align: center;
  border-radius: 25px;
  opacity: 1;
  list-style: none;
}
.bv-example .subnab .active {
  background: #07cddb;
  opacity: 1;
  color: #fff;
  position: relative;
  list-style: none;
}
.bv-example .subnab a:hover {
  background: #07cddb;
  opacity: 1;
  list-style: none;
}
a {
  color: black;
}
.bv-example .subnab a {
  letter-spacing: 0px;
  opacity: 1;
  font-size: 20px;
  font-weight: 600;
  text-decoration: none;
}
.button {
  margin-left: 16%;
}
.btn {
  border: none;
  outline: none;
  padding: 10px 16px;
  background-color: #f1f1f1;
  cursor: pointer;
  font-size: 18px;
}
/* Style the active class, and buttons on mouse-over */
.active,
.btn:hover {
  background-color: #666;
  color: white;
}
.dropbtn {
  opacity: 1;
  font-size: 18px;
  border: none;
  width: 200px;
  height: 45px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 600;
  border-bottom: 1px solid #706f6f;
  margin-left: 10px;
}
.icon-drop {
  margin-left: 200px;
  margin-top: 6px;
  float: right;
  position: absolute;
  color: #07cddb;
  font-size: 16px;
}
.dropbtn:focus,
.dropbtn:active {
  border: none;
}
select {
  margin: 0;
  padding: 0;
  margin-top: -5px;
}
option {
  color: #000;
}
option:active {
  background-color: #000;
}
.dropdown {
  position: relative;
  display: inline-block;
  z-index: 1001;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  width: 450px;
  text-align: left;

  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-weight: 600;
  margin-top: 1px;
  border-radius: 12px;
}
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content a:hover {
  background-color: #ddd;
}
.dropdown:hover .dropdown-content {
  display: block;
}

.search-container button {
  float: right;
  padding: 6px 10px;
  margin-top: 8px;
  margin-right: 12px;
  background: #ddd;
  font-size: 17px;
  border: none;
  cursor: pointer;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 8px #0000003b;
  border-radius: 12px;
  opacity: 1;
}
.select {
  margin: 0;
  padding: 0;
}
.search-container {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 8px #0000003b;
  border-radius: 12px;
  opacity: 1;
  width: 370px;
  height: 50px;
  padding-left: 5px;
}
.search-container input {
  text-align: left;
  font-size: 26px;

  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  border-radius: 12px;
  opacity: 1;
  width: 300px;
  height: 50px;
  padding: 6px 10px;
  text-decoration: none;
  border-style: none;
  font-weight: 500;
}
.search-container button:hover {
  background: #fff;
}
.search-container button {
  float: right;
  margin-top: 8px;
  margin-right: 12px;
  background: #fff;
  font-size: 17px;
  border: none;
  cursor: pointer;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 8px #fff;
  border-radius: 12px;
  opacity: 1;
  margin-top: 5px;
  padding: 6px 10px;
}
select {
  -webkit-appearance: none;
  appearance: none;
}
.container1 {
  display: block;
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .catagory {
    width: 200px;
    text-align: center;
    padding-left: -20px;
  }
}
@media (max-width: 2700px) {
  .dropdown {
    margin-right: 0px;
  }
}
@media (max-width: 1920px) {
  .dropdown {
    margin-right: 0px;
  }
}
@media (max-width: 1680px) {
  .dropdown {
    margin-right: 0px;
  }
  .bv-example .subnab a {
    font-weight: 600;
    text-decoration: none;
    font-size: 20px;
  }
  .container1 {
    width: 100%;
    height: 2vh;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: -15px;
    display: contents;
    margin-right: -100px;
  }
  .container1 .searchbox {
    margin-right: -160px;
  }
  .aside_header_content h1 {
    margin: 0;
    margin-top: 60px;
    font-size: 32px;
    font-weight: 600;
  }
  .columns_content h2 {
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    padding: 5px 0px;
  }
}
@media (max-width: 1440px) {
  .dropdown {
    margin-right: 0px;
  }
  .bv-example .subnab a {
    font-weight: 500;
    text-decoration: none;
    font-size: 18px;
    padding: 8px;
  }
  .container1 .searchbox {
    width: 220px;
    margin-right: -45px;
  }
}
@media (max-width: 1366px) {
  .dropdown {
    margin-right: 0px;
  }
  .bv-example .subnab a {
    font-weight: 500;
    text-decoration: none;
    font-size: 16px;
    padding: 8px;
    width: 110px;
    height: 40px;
  }
  .container1 .searchbox {
    width: 230px;
    margin-right: -65px;
  }
}
@media (max-width: 1280px) {
  .dropdown {
    margin-right: 0px;
  }
  .bv-example .subnab a {
    font-weight: 600;
    text-decoration: none;
    font-size: 16px;
  }
  .columns_content h2 {
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    padding: 5px 0px;
  }
  .container1 .searchbox {
    width: 230px;
    margin-right: -55px;
  }
}

@media (max-width: 1200px) {
  .button {
    margin-left: 0px;
  }
  .dropdown-content {
    width: 400px;
    font-size: 20px;
  }
  .subraw {
    list-style: none;
  }
  .bv-example .subnab a {
    font-weight: 600;
    text-decoration: none;
    font-size: 16px;
  }
  .columns_content h2 {
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    padding: 5px 0px;
  }
  .container1 .searchbox {
    width: 230px;
    margin-right: -55px;
  }
}
@media (max-width: 1140px) {
}
@media (max-width: 1024px) {
  .subraw {
    list-style: none;
    top: 40px;
    z-index: 1001;
    height: 80px;
    margin-left: 2%;
  }
  .subraw {
    list-style: none;
  }
  .button {
    margin-left: 0px;
  }

  .dropdown-content {
    width: 400px;
    font-size: 20px;
  }
  .bv-example .subnab a {
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    padding: 7px;
    width: 110px;
    height: 38px;
  }
  .three.columns {
    width: 24%;
    margin-left: -50px;
  }
  li a {
    font-size: 16px;
  }
  .dropbtn {
    opacity: 1;
    font-size: 16px;
    border: none;
    width: 140px;
    height: 40px;
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
    font-weight: 600;
    border-bottom: 1px solid #706f6f;
    margin-left: 10px;
  }
  .icon-drop {
    margin-left: 135px;
    margin-top: 3px;
    float: right;
    position: absolute;
    color: #07cddb;
    font-size: 16px;
  }
  .container1 .searchbox {
    width: 230px;
    margin-right: -65px;
  }
  .container1 .searchbox .searchbox__input {
    padding: 5px 30px;
  }

  @media (max-width: 990px) {
    .bv-example .subnab a {
      font-size: 18px;
      font-weight: 600;
      text-decoration: none;
      padding: 7px;
      width: 130px;
      height: 42px;
    }

    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 80%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .button {
      margin-left: 10px;
    }
    .dropdown {
      margin-right: auto;
      margin-left: 10%;
      right: auto;
      margin-top: 15px;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 400px;
      max-width: 43px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: 15px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      margin-right: 100%;
    }
    .dropdown-content {
      width: 400px;
      font-size: 20px;
    }
    .container {
      max-width: 860px;
    }

    .search-container {
      margin-left: -20px;
    }

    #home .bv-example-row {
      padding: 5px;
      margin-top: -10px;
    }
  }
  @media (max-width: 970px) {
    .bv-example .subnab a {
      font-size: 17px;
      font-weight: 600;
      text-decoration: none;
    }
    .container1 .searchbox .searchbox__input {
      margin-top: 0px;
    }
    .subraw {
      list-style: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .search-container input {
      font-size: 20px;
      height: 45px;
      width: 210px;
    }
    .search-container {
      font-size: 20px;
      border-radius: 12px;
      opacity: 1;
      width: 280px;
      height: 45px;
      margin-left: -30px;
    }
    .search-container button {
      font-size: 5px;
    }
    .bv-example-row {
      text-align: left;
    }
  }
  @media (max-width: 910px) {
    .bv-example .subnab a {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      margin-left: 5px;
    }

    .subraw {
      list-style: none;
      list-style: none;
      padding-bottom: 100px;
      width: 90%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .search-container input {
      font-size: 20px;
      height: 45px;
      width: 240px;
    }
    .search-container {
      font-size: 20px;
      border-radius: 12px;
      opacity: 1;
      width: 280px;
      height: 45px;
      margin-left: -30px;
    }
    .search-container button {
      font-size: 5px;
    }
    .bv-example-row {
      text-align: left;
    }
  }
  @media (max-width: 850px) {
    .bv-example .subnab a {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      margin-left: 5px;
    }

    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 90%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .search-container input {
      font-size: 20px;
      height: 45px;
      width: 240px;
    }
    .search-container {
      font-size: 20px;
      border-radius: 12px;
      opacity: 1;
      width: 280px;
      height: 45px;
      margin-left: -30px;
    }
    .search-container button {
      font-size: 5px;
    }
    .bv-example-row {
      text-align: left;
    }
  }
  @media (max-width: 810px) {
    .bv-example .subnab a {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
    }

    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 95%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .dropdown {
      margin-right: auto;
      margin-left: 10%;
      right: auto;
      margin-top: 15px;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .search-container input {
      font-size: 20px;
      height: 45px;
      width: 240px;
    }
    .search-container {
      font-size: 20px;
      border-radius: 12px;
      opacity: 1;
      width: 280px;
      height: 45px;
      margin-left: -20px;
    }
    .search-container button {
      font-size: 5px;
    }
    .bv-example-row {
      text-align: left;
    }

    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 400px;
      max-width: 40px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: 15px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      margin-right: 100%;
    }

    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;
      padding: 6px 30px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox .searchbox__input::placeholder {
      color: #fff;
    }
    .container1 .searchbox:focus-within .searchbox__input::placeholder {
      color: #24233a;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      font-size: 18px;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -8px;
    }

    .container1 .searchbox .searchbox__icon path {
      fill: rgb(0, 119, 255);
      transition: 0.4s linear;
    }
    .container1 .searchbox:focus-within {
      max-width: 100%;
    }
    .container1 .searchbox:focus-within .searchbox__input {
      background-color: #fff;
      padding-right: 50px;
      color: #24233a;
    }
    .container1 .searchbox:focus-within .searchbox__icon path {
      fill: rgb(0, 119, 255);
    }
    .search-container {
      display: none;
    }
  }
  @media (max-width: 767px) {
    .bv-example .subnab a {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
    }
    #icon-search {
      transform: translate(0px, -5px);
      -ms-transform: translate(0px, -5px); /* IE 9 */
      -webkit-transform: translate(0px, -5px); /* Safari and Chrome */
      -o-transform: translate(0px, -5px); /* Opera */
      -moz-transform: translate(0px, -5px);
    }
    .bv-example .subnab .active {
      border-radius: 12px;
      opacity: 1;
      position: relative;
      list-style: none;
    }
    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 100%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .search-container input {
      font-size: 20px;
      height: 45px;
      width: 200px;
    }
    .search-container {
      font-size: 1px;
      border-radius: 12px;
      opacity: 1;
      width: 240px;
      height: 45px;
      position: absolute;
      float: right;
      margin-left: 130px;
      margin-top: -45px;
      left: 35%;
    }
    .search-container button {
      font-size: 5px;
    }
    .bv-example-row {
      text-align: left;
    }

    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 100%;
      max-width: 40px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      margin-right: 10%;
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox .searchbox__input::placeholder {
      color: #fff;
    }
    .container1 .searchbox:focus-within .searchbox__input::placeholder {
      color: #24233a;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -8px;
    }
    .container1 .searchbox .searchbox__icon path {
      fill: rgb(0, 119, 255);
      transition: 0.4s linear;
    }
    .container1 .searchbox:focus-within {
      max-width: 300px;
    }
    .container1 .searchbox:focus-within .searchbox__input {
      background-color: #fff;
      padding-right: 50px;
      color: #24233a;
    }
    .container1 .searchbox:focus-within .searchbox__icon path {
      fill: rgb(0, 119, 255);
    }
    .search-container {
      display: none;
    }
  }
  @media (max-width: 720px) {
    .bv-example .subnab a {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      width: 120px;
      height: 38px;
    }
    .bottom_content_info p {
      bottom: -11px;
      font-size: 12px;
      width: 70vw;
      position: absolute;
      background: rgb(29 28 28 / 92%);
      padding: 5px 0px 10px 90px;
      margin-left: -120px;
      line-height: normal;
    }
    .bv-example .subnab .active {
      position: relative;
      list-style: none;
    }
    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 100%;
      text-align: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 100%;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      z-index: 1001;
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;
      padding: 6px 30px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox .searchbox__input::placeholder {
      color: #fff;
    }
    .container1 .searchbox:focus-within .searchbox__input::placeholder {
      color: #24233a;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }
    .container1 .searchbox .searchbox__icon path {
      fill: rgb(0, 119, 255);
      transition: 0.4s linear;
    }
    .container1 .searchbox:focus-within {
      max-width: 250px;
    }
    .container1 .searchbox:focus-within .searchbox__input {
      background-color: #fff;
      padding-right: 50px;
      color: #24233a;
    }
    .container1 .searchbox:focus-within .searchbox__icon path {
      fill: rgb(0, 119, 255);
    }
    .search-container {
      display: none;
    }
    .dropbtn {
      font-size: 14px;
    }
  }
  @media (max-width: 683px) {
    .bv-example .subnab a {
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      width: 100px;
      height: 38px;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }

    .subraw {
      list-style: none;
      position: initial;
      margin-top: 20px;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 4px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }

    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 370px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -35px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;

      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox .searchbox__input::placeholder {
      color: #fff;
    }
    .container1 .searchbox:focus-within .searchbox__input::placeholder {
      color: #24233a;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }
    .container1 .searchbox .searchbox__icon path {
      fill: rgb(0, 119, 255);
      transition: 0.4s linear;
    }
    .container1 .searchbox:focus-within {
      max-width: 250px;
    }
    .container1 .searchbox:focus-within .searchbox__input {
      background-color: #fff;
      padding-right: 50px;
      color: #24233a;
    }
    .container1 .searchbox:focus-within .searchbox__icon path {
      fill: rgb(0, 119, 255);
    }
    .search-container {
      display: none;
    }
  }
  @media (max-width: 650px) {
    .bv-example .subnab a {
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }
    .bv-example .subnab .active {
      border-radius: 6px;
      opacity: 1;
      padding: 8px 9px 8px 9px;
      color: #fff;
      position: relative;
      list-style: none;
    }
  }
  @media (max-width: 620px) {
    .bv-example .subnab a {
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }

    .subraw {
      list-style: none;
      position: initial;
      margin-top: 20px;
    }
    .container1 .searchbox:focus-within {
      max-width: 210px;
    }
  }
  @media (max-width: 600px) {
    .bv-example .subnab a {
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }
    .bv-example .subnab .active {
      border-radius: 6px;
      opacity: 1;
      padding: 10px 6px 10px 6px;
      color: #fff;
      position: relative;
      list-style: none;
    }
    .bottom_content_info p {
      bottom: -12px;
      font-size: 12px;
      width: 75vw;
      position: absolute;
      background: rgb(29 28 28 / 92%);
      padding: 5px 10px 10px 110px;
      margin-left: -120px;
      line-height: normal;
    }
  }
  @media (max-width: 580px) {
    .bv-example .subnab a {
      font-size: 12px;
      font-weight: 600;
      text-decoration: none;
      width: 80px;
      height: 32px;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }

    .subraw {
      list-style: none;
      position: initial;
      margin-top: 10px;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 4px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }

    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 100%;
      max-width: 40px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -35px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox .searchbox__input::placeholder {
      color: #fff;
    }
    .container1 .searchbox:focus-within .searchbox__input::placeholder {
      color: #24233a;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -8px;
    }
    .container1 .searchbox .searchbox__icon path {
      fill: rgb(0, 119, 255);
      transition: 0.4s linear;
    }
    .container1 .searchbox:focus-within {
      max-width: 210px;
    }
    .container1 .searchbox:focus-within .searchbox__input {
      background-color: #fff;
      padding-right: 50px;
      color: #24233a;
    }
    .container1 .searchbox:focus-within .searchbox__icon path {
      fill: rgb(0, 119, 255);
    }
    .search-container {
      display: none;
    }
  }
  @media screen and (max-width: 680px) and (orientation: landscape) {
    .carousel-caption {
      position: absolute;
      right: auto;
      bottom: 30%;
      left: 15%;
      z-index: 10;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #fff;
      text-align: center;
    }
    .carousel-caption h5 {
      font-size: 16px;
      margin-top: -30%;
    }
  }
  @media screen and (max-width: 533px) and (orientation: landscape) {
    .row_home_right {
      float: left;
      margin-top: -8%;
      padding: 10px 20px;
      padding: 6px 15px;
      margin-left: -2px;
    }
  }
  @media (max-width: 560px) and (orientation: portrait) {
    .carousel-caption {
      position: absolute;
      right: auto;
      bottom: 25%;
      left: 15%;
      z-index: 10;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #fff;
      text-align: center;
    }
    .carousel-caption h5 {
      font-size: 16px;
      margin-top: -55%;
    }
  }
  @media (max-width: 325px) and (orientation: portrait) {
    .carousel-caption {
      position: absolute;
      right: auto;
      bottom: 5%;
      left: 15%;
      z-index: 10;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #fff;
      text-align: center;
    }
  }
  @media (max-width: 560px) {
    .bv-example .subnab a {
      font-size: 12px;
      font-weight: 600;
      text-decoration: none;
    }
    .button {
      margin-left: 20px;
    }
    .subnav {
      width: 160px;
    }
    .bottom_content_info p {
      bottom: -11px;
      font-size: 12px;
      width: 80vw;
      position: absolute;
      background: rgb(29 28 28 / 92%);
      padding: 5px 10px 10px 110px;
      margin-left: -120px;
      line-height: normal;
    }
  }
  @media (max-width: 500px) {
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 370px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -35px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
  }
  @media (max-width: 540px) {
    .phone-nav {
      display: block;
      margin-left: 10px;
    }

    .container {
      list-style: none;
    }
    .button {
      margin-left: 15px;
    }
    .subraw li {
      height: 43px;
    }
    .subnav {
      width: 280px;
    }
    .form-row .subnab a {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      border-radius: 6px;
      color: #000;
      position: relative;
      list-style: none;
      font-size: 14px;
      height: auto;
      width: 170px;
      padding: 14px;
      font-weight: 600;
    }
    .form-row {
      height: 160px;
      margin-left: 10px;
      margin-right: 4px;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .colo-five {
      text-align: center;
      margin-left: 100px;
    }
    .form-row .subnab .active {
      background: transparent linear-gradient(289deg, #0077ff 0%, #00b0ff 100%) 0% 0%
        no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      color: #fff;
      position: relative;
      list-style: none;
      font-size: 14px;
      padding: 14px;
    }
    .subraw {
      list-style: none;
      position: initial;
      margin-top: 10px;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 3px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }
    .dropdown {
      padding-left: 10px;
    }
    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 400px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -35px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;

      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox:focus-within {
      max-width: 405px;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }

    .containers-nav {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
    .bottom_content_info p {
      bottom: -11px;
      font-size: 12px;
      width: 95vw;
      position: absolute;
      background: rgb(29 28 28 / 92%);
      padding: 5px 10px 10px 110px;
      margin-left: -120px;
      line-height: normal;
    }
  }
  @media (max-width: 465px) {
    .bv-example .subnab a {
      font-size: 12px;
      font-weight: 600;
      text-decoration: none;
      width: 70px;
      height: 28px;
      padding: 4px;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 340px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
  }
  @media (max-width: 431px) {
    .phone-nav {
      display: block;
      margin-left: 10px;
    }

    .container {
      list-style: none;
    }
    .button {
      margin-left: 15px;
    }
    .subraw li {
      height: 43px;
    }
    .subnav {
      width: 280px;
    }
    .form-row .subnab a {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      border-radius: 6px;
      color: #000;
      position: relative;
      list-style: none;
      font-size: 14px;
      height: 45px;
      width: 150px;
      padding: 14px;
      font-weight: 600;
    }
    .form-row {
      height: 160px;
      margin-left: 10px;
      margin-right: 4px;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .colo-five {
      text-align: center;
      margin-left: 85px;
    }
    .form-row .subnab .active {
      background: transparent linear-gradient(289deg, #0077ff 0%, #00b0ff 100%) 0% 0%
        no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      color: #fff;
      position: relative;
      list-style: none;
      font-size: 14px;
      padding: 14px;
    }
    .subraw {
      list-style: none;
      position: initial;
      margin-top: 10px;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 3px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }
    .dropdown {
      padding-left: 10px;
    }
    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 320px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;

      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox:focus-within {
      max-width: 360px;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }

    .containers-nav {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (max-width: 418px) {
    .bv-example .subnab a {
      font-size: 11px;
      font-weight: 600;
      text-decoration: none;
      width: 60px;
      height: 25px;
      padding: 4px;
    }
    .bottom_content_info p {
      bottom: -11px;
      font-size: 12px;
      width: 100vw;
      position: absolute;
      background: rgb(29 28 28 / 92%);
      padding: 0px 0px 10px 40px;
      margin-left: -40px;
      line-height: normal;
    }
  }
  @media (max-width: 397px) {
    .phone-nav {
      display: block;
      margin-left: 10px;
    }

    .container {
      list-style: none;
    }
    .button {
      margin-left: 15px;
    }
    .subraw li {
      height: 43px;
    }
    .subnav {
      width: 280px;
    }
    .form-row .subnab a {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      border-radius: 6px;
      color: #000;
      position: relative;
      list-style: none;
      font-size: 14px;
      height: 45px;
      width: 130px;
      padding: 14px;
      font-weight: 600;
    }
    .form-row {
      height: 160px;
      margin-left: 10px;
      margin-right: 4px;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .colo-five {
      text-align: center;
      margin-left: 75px;
    }
    .form-row .subnab .active {
      background: transparent linear-gradient(289deg, #0077ff 0%, #00b0ff 100%) 0% 0%
        no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      color: #fff;
      position: relative;
      list-style: none;
      font-size: 14px;
      padding: 14px;
    }
    .subraw {
      list-style: none;
      position: initial;
      margin-top: 10px;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 3px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }
    .dropdown {
      padding-left: 10px;
    }
    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 280px;
      max-width: 40px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      border-radius: 50px;
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox:focus-within {
      max-width: 320px;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }

    .containers-nav {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (max-width: 370px) {
    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 80%;
      text-align: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      height: 200px;
    }
    .dropdown {
      margin-right: auto;
      margin-left: 15px;
      right: auto;
      margin-top: 15px;
    }
    .bv-example .subnab a {
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      width: 110px;
      height: 32px;
      padding: 4px;
    }
    .container1 .searchbox {
      margin-right: 0px;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 260px;
      max-width: 40px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
      border-radius: 50px;
    }
  }
  @media (max-width: 347px) {
    .phone-nav {
      display: block;
      margin-left: 10px;
    }

    .container {
      list-style: none;
    }
    .button {
      margin-left: 15px;
    }
    .subraw li {
      height: 43px;
    }
    .subnav {
      width: 280px;
    }

    .form-row .subnab a {
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      border-radius: 6px;
      color: #000;
      position: relative;
      list-style: none;
      font-size: 14px;
      height: auto;
      width: 130px;
      padding: 12px;
      font-weight: 600;
    }
    .form-row {
      height: 160px;
      margin-left: -8px;
      margin-right: 4px;
      margin-top: 15px;
      margin-bottom: 10px;
    }
    .colo-five {
      text-align: center;
      margin-left: 70px;
    }
    .form-row .subnab .active {
      background: transparent linear-gradient(289deg, #0077ff 0%, #00b0ff 100%) 0% 0%
        no-repeat padding-box;
      box-shadow: 0px 2px 6px #00b0ff73;
      color: #fff;
      position: relative;
      list-style: none;
      font-size: 12px;
      padding: 12px;
    }
    .subraw {
      list-style: none;
      padding-bottom: 100px;
      width: 80%;
      text-align: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }
    #icon-search {
      margin-left: -10px;
      position: absolute;
      margin-top: -25px;
    }
    hr {
      position: initial;
    }
    .subraw1 {
      display: none;
    }
    .dropdown-content {
      width: 200px;
      font-size: 20px;
    }

    .icon-drop1 {
      position: absolute;
      margin-right: 30px;
      margin-left: -30px;
      margin-top: 3px;
    }
    #nav {
      margin-bottom: 20px;
    }
    .bv-example-row {
      text-align: left;
      margin-top: -45px;
    }

    .container1 {
      width: 100vw;
      height: 2vh;
      display: flex;
      align-items: center;
      margin-top: -25px;
      display: contents;
    }
    .container1 .searchbox {
      position: relative;
      display: block;
      width: 230px;
      max-width: 41px;
      transition: 0.4s linear;
      overflow: hidden;
      float: right;
      margin-top: -40px;
      box-shadow: 0px 2px 6px rgba(22, 24, 24, 0.451);
    }
    .container1 .searchbox .searchbox__input {
      display: block;
      appearance: none;
      width: 100%;
      border: none;
      outline: none;
      border-radius: 50px;

      padding-left: 15px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      transition: 0.4s linear;
      font-weight: 600;
    }
    .container1 .searchbox:focus-within {
      max-width: 300px;
    }
    .container1 .searchbox .searchbox__icon {
      position: absolute;
      right: calc(53px / 2);
      top: 50%;
      transform: translate(50%, -50%);
      width: 20px;
      height: 20px;
      pointer-events: none;
      margin-right: -6px;
    }

    .containers-nav {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
  }
}
</style>
